module.exports = __webpack_public_path__ + "static/media/26-4.76765756.mp3";